import axios from './base';

/**
 * 获取计划列表
 * @param {*} params
 * @returns
 */
export const getPlanList = (params) => {
  return axios.post('/plan/getList', params);
};

/**
 * 创建计划
 * @param {*} data
 * @returns
 */
export const createPlan = (data) => {
  return axios.post('/plan/createPlan', data);
};

/**
 * 获取计划详情
 * @param {*} planId
 * @returns
 */
export const getPlanDetail = (planId) => {
  return axios.get('/plan/getMeta', { params: { planId } });
};

/**
 * 更新计划meta
 * @param {*} data
 * @returns
 */
export const updatePlanMeta = (data) => {
  return axios.post('/plan/updateMeta', data);
};

/**
 * 删除计划
 * @param {*} data
 * @returns
 */
export const deletePlan = (data) => {
  return axios.post('/plan/deletePlan', data);
};

/**
 * 发布计划
 * @param {*} planId
 * @returns
 */
export const publishPlan = (params) => {
  return axios.post('/plan/publishPlan', params);
};
// 撤销发布计划
export const cancelPublishPlan = (params) => {
  return axios.post('/plan/publishPlan/cancel', params);
};

/**
 * 归档计划
 * @param {*} planId
 * @returns
 */
export const archivePlan = (params) => {
  return axios.post('/plan/archivePlan', params);
};

// -----------------------------------任务分配---------------------------------
// 获取可分配调查对象数据
export const getNotDistributionSubjects = (params) => {
  return axios.get('/plan/getSubjectList/notDistribution', params);
};

// 分配任务
export const distributionTask = (data) => {
  return axios.post('/planTask/distribution', data);
};
// 设置固定检查时间段
export const setSurveyTime = (data) => {
  return axios.post('/planTask/setSurveyTime', data);
};
// 关注计划
export const focusPlan = (params) => {
  return axios.get('/plan/focus', { params: { ...params } });
};
// 计划管理员获取已分配任务列表
export const distributionList = (params) => {
  return axios.get('/planTask/distributionList', params);
};

// 删除分配记录
export const deldistributionItem = (params) => {
  return axios.get('/planTask/delete', { params: { ...params } });
};

// 获取调查员分配记录
export const getDistributionByOfficer = (params) => {
  return axios.get('/planTask/getDistributionByOfficer', params);
};

// 任务统计列表
export const statisticsOwner = (data) => {
  return axios.post('/planTask/statisticsTaskInfo', data);
};

// 获取任务统计数量 待完成、已归档、待审批
export const statisticsTaskCount = (planId) => {
  return axios.get('/planTask/statisticsTaskCount', { params: { planId } });
};
// 取消任务详情
export const getCancelTaskDetail = (planTaskId) => {
  return axios.get('/planTask/cancel/detail', { params: { planTaskId } });
};
// 任务详情
export const getTaskDetail = (planTaskId) => {
  return axios.get('/planTask/getTaskDetail', { params: { planTaskId } });
};
// 获取任务回退原因
export const getTaskDetailResonsReadOnly = (planTaskId) => {
  return axios.get('/planTask/cancel/reason', { params: { planTaskId } });
};

// 已归档-已取消任务重新分配
export const reDistributionTask = (data) => {
  return axios.post('/planTask/cancelStatus/distribution', data);
};
// 关注/取消关注任务
export const setTaskFollowStatus = (params) => {
  return axios.get('/planTask/focus', { params: { ...params } });
};
// 查询关注的问题
export const getFocusQuestionId = (params) => {
  return axios.get('/planTask/surveyFocus/getField', { params: { ...params } });
};
// 关注/取消关注问题
export const setQuestionFocusStatus = (data) => {
  return axios.post('/planTask/survey/focus', data);
};
// ------------------------------------任务审批------------------------------
// 提交任务审批-同意
export const approvalSubmitAgree = (data) => {
  return axios.post('/planTask/Approval/response/agree', data);
};

// 提交任务审批-拒绝
export const approvalSubmitReject = (data) => {
  return axios.post('/planTask/Approval/response/reject', data);
};

// 取消任务审批-同意
export const approvalCancelAgree = (data) => {
  return axios.post('/planTask/Approval/cancel/agree', data);
};

// 取消任务审批-拒绝
export const approvalCancelReject = (data) => {
  return axios.post('/planTask/Approval/cancel/reject', data);
};
